import emptySliceApi from '../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    UpdateAccountName: builder.mutation<
      void,
      { accountId: string; name: string }
    >({
      query: ({ accountId, name }) => ({
        url: `v4/accounts/${accountId}/name`,
        method: 'PUT',
        body: { name },
      }),
      invalidatesTags: ['AccountData'],
    }),
  }),
});

export const { useUpdateAccountNameMutation } = apiSlice;
